import { Card, Menu, Row, Spin, Typography, message } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useParams } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import HTTPClient from "../../utils/HTTPClient";
import { InitialPage } from "./InitialPage";
import { SingleAppDetail } from "./SingleAppDetail";
import { useTranslation } from "react-i18next";

export default function DettaglioApp({}) {
    const [userApp, setUserApp] = useState(null);
    const [user, setUser] = useLocalStorage("user", null);
    const [current, setCurrent] = useState(null);
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const { appName, tabName } = useParams();

    useEffect(() => {
        getData();
    }, []);

    const getData = async (selectedTab) => {
        setLoading(true);
        const resApp = await HTTPClient.get("/app/" + appName);
        if (!resApp.data) return message.error(t("dettaglio_app.not_found"));
        const app = resApp.data;

        const resAppsBundles = await HTTPClient.get("/app/_app_typologies");
        if (resAppsBundles?.data) {
            const present = resAppsBundles.data.find((a) => a.value === app.technology);
            if (present) app.img = present.img;
        }
        setUserApp(app);

        const tmpMenuItems = [
            {
                key: "initial_page",
                label: t("dettaglio_app.general_info"),
                onClick: () => {
                    setCurrent("initial_page");
                },
                content: (
                    <InitialPage
                        userApp={app}
                        appName={appName}
                        getData={getData}
                        setUser={setUser}
                    />
                ),
            },
        ];
        const isGithubConnected = app.apps.find(
            (item) => item.github_repo && item.github_repo.id !== null
        )
            ? true
            : false;
        app.apps.forEach((item, index) => {
            if (item.hidden) return;
            if (item.technology === "filebrowser" && isGithubConnected) return;
            if (!app.active) return;
            tmpMenuItems.push({
                key: item.technology,
                label: item.technology,
                onClick: () => {
                    setCurrent(index);
                },
                content: (
                    <SingleAppDetail
                        app={item}
                        appName={appName}
                        getData={getData}
                        appBundleTechnology={app.technology}
                        lastDeployDatetime={app.last_deploy_datetime}
                    />
                ),
            });
        });

        setMenuItems(tmpMenuItems);
        if (selectedTab) {
            setCurrent(selectedTab);
        } else {
            setCurrent(tabName || tmpMenuItems[0].key);
        }
        setLoading(false);
    };

    const handleMenuClick = (item) => {
        setCurrent(item.key);
    };

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    if (loading) {
        return (
            <Row
                style={{
                    padding: isLargeScreen ? "20px 50px" : "10px 10px",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    minHeight: "50vh",
                }}>
                {" "}
                <Spin size="large" />
            </Row>
        );
    }

    return (
        <Row style={{ padding: isLargeScreen ? "20px 50px" : "10px 10px" }}>
            <Card
                style={{ width: "100%" }}
                cover={
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "center",
                            height: "auto",
                            alignItems: "center",
                        }}>
                        <div
                            style={{
                                width: "200px",
                            }}>
                            <img src={userApp?.img} style={{ width: "100%", height: "auto" }} />
                        </div>
                    </div>
                }>
                <Card.Meta
                    title={
                        <Typography.Text
                            style={{ fontSize: "x-large", textTransform: "uppercase" }}>
                            {appName}
                        </Typography.Text>
                    }
                    description={
                        <Typography.Text style={{ fontWeight: "300" }}>
                            {t("dettaglio_app.buy_on")}:{" "}
                            {moment(userApp?.creation_date).format("DD/MM/YYYY")}
                            <br />
                        </Typography.Text>
                    }
                />
                <Menu
                    style={{ width: "100%" }}
                    onClick={handleMenuClick}
                    selectedKeys={[current]}
                    mode="horizontal"
                    items={menuItems}
                />

                {current ? menuItems.find((item) => item.key === current).content : null}
            </Card>
        </Row>
    );
}
